import { getStateWithOnlyOneLevel } from '../../utils/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'login');
}

export const getErrors = (state) => getState(state).get('errors');
export const getSuccessful = (state) => getState(state).get('successful');
export const getMessage = (state) => getState(state).get('message');
export const getUser = (state) => getState(state).get('user');
export const getLoading = (state) => getState(state).get('loading');
export const getlastNotificationsRequest = (state) =>
  getState(state).get('lastNotificationsRequest');
export const getlastUserNotificationsRequest = (state) =>
  getState(state).get('lastUserNotificationsRequest');
export const getCantStudy = (state) => getState(state).get('cantStudy');
export const getUserSettingQualForDailyQuizMessage = (state) =>
  getState(state).get('userSettingQualForDailyQuizMessage');
export const getLoadingQualForDailyQuizSelector = (state) =>
  getState(state).get('loadingUpdateUserSettingQualForDailyQuiz');
